<template>
<b-row class="ted-flares4 no-gutters">

    <b-col class="tool-border" cols="12">
        <tedtfHeader :image="'triggers'" :screenTitle="'Triggers for TED Flares'"></tedtfHeader>
        <b-col class="page-background-gradient reduce-padding" cols="12">
            <b-row class="page-content no-gutters">
                <div class="body-sec">
                    <b-row class="no-gutters">
                        <b-col class="reduce-padding" cols="12">
                            <div class="main-text">
                                The following are potential triggers for TED flares.<br>
                                Please check the box if any of the following 9 questions are true for you:
                            </div>
                        </b-col>
                        <b-col class="reduce-padding" cols="12">
                            <b-row class="no-gutters">
                                <b-col class="reduce-padding" cols="12">
                                      <b-row class=" no-gutters">
                                        <b-col class="reduce-padding" lg="7" md="8" sm="12">
                                            <div class="ques-sec">
                                            <div class="key-image"></div>
                                            <div class="ques-heading"> Do you have an autoimmune condition? </div>
                                             <div class="ques-sub-heading">Some examples include:</div>
                                             <div class="list">
                                                <li>Rheumatoid arthritis</li>
                                                <li>Vitiligo</li>
                                                <li>Psoriasis</li>
                                                <li>Multiple sclerosis</li>
                                                <li>Lupus</li>
                                                <li>Crohn's disease</li>
                                                <li>Type 1 diabetes</li>
                                            </div>
                                                <b-row class="checkbox-area">

                                                    <b-col cols="6" class="reduce-padding">
                                                        <div class="ted-radio ">
                                                            <input @click="tagInput('Autoimmune Condition', 'Yes' )" type="radio" name="conditionsYes" v-model="userData.conditions" id="conditionsYes" value="conditionsYes">
                                                            <label for="conditionsYes">
                                                                <div class="checkbox-label">YES</div>
                                                            </label>
                                                        </div>
                                                    </b-col>

                                                    <b-col cols="6" class="reduce-padding">
                                                        <div class="ted-radio top-margin">
                                                            <input @click="tagInput('Autoimmune Condition', 'No' )" type="radio" name="conditionsNo" v-model="userData.conditions" id="conditionsNo" value="conditionsNo">
                                                            <label class="no-label" for="conditionsNo">
                                                                <div class="checkbox-label">NO</div>
                                                            </label>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                         </div>
                                        </b-col>

                                        <b-col class="reduce-padding" lg="5" md="4" sm="12">
                                            <div class="right-box ">
                                                <div class="box"><p class="box-inside-text line1">About 14% of TED patients have another autoimmune condition that is not thyroid-related.*</p>
                                                <p class="box-inside-text line2">In these patients, TED tends to be more active and severe.</p></div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                
                                <b-col class="reduce-padding" cols="12">
                                    <div class="note-text"><sup>*</sup>Based on 1 study of 267 patients.</div>
                                </b-col>  
                            </b-row>
                        </b-col>

                    </b-row>
                </div>
            </b-row>
        </b-col>        <tedftNavigation v-bind:navButtons="['next','back', 'showMidCol']" :currentScreen="7" :isSymptom="true" :isHideMenu="false"></tedftNavigation>
    </b-col>

</b-row>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
import taggingMixin from "../mixins/taggingMixin";
    import tedtfHeader from '../components/tedtfHeader.vue';
    import tedftNavigation from '../components/tedftNavigation.vue';

    export default {
        name: "tedFlares",
        mixins: [taggingMixin],
        mounted: function() {
        },
        components: {
  'tedtfHeader': tedtfHeader,
            'tedftNavigation': tedftNavigation
        },

        computed: {
             ...mapGetters('userData', ['userData'])
        },

        methods: {
        },

        data() {
            return {};
        },
    };
</script>


<style lang="scss" scoped>
</style>
